function getPrimarySubtag(tag: string): string {
  return (tag.split("-")[0] ?? tag).toLowerCase();
}

/**
 * The text of a per-locale record (`{ de: "…", en: "…" }`) for a locale: the
 * exact tag first, then the same primary language (`de` for `de-DE`, a record
 * `en-US` for `en-GB`). A record without a text for the language has none: the
 * caller falls back to a translated sentence instead of showing another
 * language.
 */
export function pickLocalizedText(
  text: Readonly<Record<string, string>> | undefined,
  locale: string,
): string | undefined {
  if (!text) {
    return undefined;
  }

  const entries = Object.entries(text).filter(([, value]) => value.length > 0);
  const wanted = locale.toLowerCase();
  const exact = entries.find(([tag]) => tag.toLowerCase() === wanted);
  if (exact) {
    return exact[1];
  }

  const primary = getPrimarySubtag(locale);
  const primaryOnly = entries.find(([tag]) => tag.toLowerCase() === primary);
  const sameLanguage =
    primaryOnly ?? entries.find(([tag]) => getPrimarySubtag(tag) === primary);
  return sameLanguage?.[1];
}
